'use client';

import React, { ReactNode, useEffect } from 'react';

type Props = { children: ReactNode };

export function DevA11yProvider({ children }: Props) {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;

    Promise.all([import('@axe-core/react'), import('react-dom/client')]).then(
      async ([axeReact, ReactDOMClient]) => {
        const reactAxe = axeReact.default;

        const config = {
          rules: [
            { id: 'color-contrast', enabled: false },
            { id: 'color-contrast-enhanced', enabled: false }
          ]
        };

        await reactAxe(React, ReactDOMClient, 1000, config);

        console.log(
          'Axe DevTools initialized. Open the console to see the results of accessibility checks.'
        );
      }
    );
  }, []);

  return <>{children}</>;
}
